export class Address {
    streetNumber?: string; // number
    route?: string; // street
    locality?: string; // city
    regionCode?: string; // country code
    country?: string; // country name
    postalCode?: string; // zipcode
    formattedAddress?: string; // formatted string
    administrativeArea?: string; // formatted string

    public constructor(init?: Partial<Address>) {
        this.streetNumber = init?.streetNumber;
        this.route = init?.route;
        this.locality = init?.locality;
        this.regionCode = init?.regionCode;
        this.country = init?.country;
        this.postalCode = init?.postalCode;
        this.formattedAddress = init?.formattedAddress;
        this.administrativeArea = init?.administrativeArea;
    }
}
